<template>
<div class="Dashboard">
  <div class="container">
    <div class="row box-home">
      <div class="col s12 m5"> &nbsp; </div>
      <div class="col s12 m7">
        <div><img class="responsive-img" src="https://imageresizer.arch.software/astoninternational/v2/Images/Page/logo/logo1-aii.png?d=374x132&location=center" alt="Archipelago International" /></div>
        <h4><small>Welcome to</small><br /> ARCH STAFF INFORMATION CHANNEL</h4>
        <div class="welcome_txt" v-html="PageContent">
        </div>
        <div class="box-btn">
          <div v-for="menu in PageData.pagelink" class="col s12 m6 top-logo">
            <router-link class="waves-effect waves-light btn btn-menu grey lighten-4" :to="menu.link">
              <img :src="menu.icon" :alt="menu.linkname" />
              {{menu.linkname}}
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>

  <div class="button-notif" data-balloon="Whats new!" data-balloon-pos="left"><a @click="show()" class="modal-trigger btn-floating btn-large waves-effect waves-light pulse green"><i class="material-icons">info_outline</i></a></div>

  <modal name="info" height="auto">
    <div class="row">
      <div class="col m12 modalinfo">
        <h4 class="center-align">What's New</h4>
        <ul>
          <li v-for="notif in PageData.notification">
            <a href="#">{{notif.document}}</a><br /><small>{{notif.message}}</small>
          </li>
        </ul>
        <br />
        <div class="center-align">
          <button class="waves-effect waves-light btn grey darken-1" @click="hide()">Close</button>
        </div>
        <br />
      </div>
    </div>
  </modal>

  <div class="footer">
    <p>Copyright &copy; {{new Date().getFullYear()}} Archipelago International</p>
  </div>
</div>
</template>

<script>
import axios from 'axios'
import router from '../router'
export default {
  name: 'Dashboard',
  data() {
    return {
      usercookie: $cookies.get('arch-asic'),
      PageData: [],
      PageContent: ''
    }
  },
  methods: {
    show() {
      this.$modal.show('info');
    },
    hide() {
      this.$modal.hide('info');
    },
    fetchDataDashboard: function() {
      axios({
        method: 'post',
        url: 'https://www.archipelagointernational.com/api/asic/query',
        data: {
          query: `
          query {
              pagelink {
                  linkname,
                  link,
                  icon
              },
              loadpage(name:"HOMEPAGE") {
                  background,
                  content
              },
              notification {
                  document,
                  message
              }
          }
        `
        },
        headers: {
          'Authorization': 'Bearer ' + this.usercookie,
          'Content-Type': 'application/json'
        }
      }).then(response => (this.PageData = response.data.data, this.PageContent = response.data.data.loadpage.content));
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === 'addClass') {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    loginstatus: function(e) {
      if (e != 'Success') {
        router.push({
          name: 'Login'
        })
      } else {
        //this.isLogin = true
        //console.log(e);
      }
    }
  },
  created() {
    this.fetchDataDashboard();
  },
  mounted() {
    this.toggleBodyClass('removeClass', 'bm-overlay');
    this.toggleBodyClass('addClass', 'back-dashboard');
  },
  destroyed() {
    this.toggleBodyClass('removeClass', 'back-dashboard');
  }
}
</script>

<style>
.back-dashboard {
  background: url('https://cdn0.archipelagointernational.com/StaffCentre/assets/images/test2.jpg') center center no-repeat fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue